import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Roles } from 'src/app/shared/services/names.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-forbidden',
  templateUrl: './forbidden.component.html',
  styleUrls: ['./forbidden.component.scss']
})
export class ForbiddenComponent implements OnInit {

  constructor(private router:Router, private authService:AuthService) { }

  ngOnInit(): void {
  }
  GotoDashboard(){
  this.navigateToDashboard()
  }
  async navigateToDashboard(){
    let userRoles = await this.authService.getUserRoles()
    if(userRoles === Roles.adminUser || userRoles === Roles.cprUser){
    // localStorage.setItem("activeDashboard",Roles.cprUser)
    this.router.navigate(['/app/dashboard']);

    }else{
      this.router.navigate(['/app/dashboard/mkt']);

      // localStorage.setItem("activeDashboard",Roles.mktUser)

    }
  }
}
